export default "__VITE_ASSET__DZOmhPFD__"